import { defineMessages, useIntl } from "react-intl"
import { Stage } from "src/components"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import { ModelInformationDetails } from "./components/ModelInformationDetails"
import { ModelInformationSkeleton } from "./components/ModelInformationSkeleton"
import { useModelInformation } from "./hooks/useModelInformation/useModelInformation"

const messages = defineMessages({
	title: {
		defaultMessage: "Model information",
		id: "vehicleDetails.overview.modelInformation.title",
	},
})

export const ModelInformationContainer = withErrorHandler(() => {
	const { formatMessage } = useIntl()
	const modelInformation = useModelInformation()
	return (
		<Stage title={formatMessage(messages.title)}>
			<ErrorNotificationInline dismissButton={false} />
			{modelInformation ? (
				<ModelInformationDetails {...modelInformation} />
			) : modelInformation === undefined ? (
				<ModelInformationSkeleton />
			) : null}
		</Stage>
	)
})
